import React from 'react';
import Helmet from 'react-helmet';

import HelpContactUs from '../../../components/HelpContactUs/HelpContactUs';
import SheetTitle from '../../../components/SheetTitle';
import BackButton from '../../../components/BackButton';
import c from '../Help.less';

export default function ArchiveDoesntUnzip() {
  return (
    <div className={c.content}>
      <Helmet defer={false}>
        <meta property="mc:dp" content="/shop/help/archive-doesnt-unzip" />
      </Helmet>
      <BackButton to="/shop/help" />
      <SheetTitle title="The archive doesn't unzip" />
      <p>
        If your archive doesn&apos;t unzip, please check the following issues:
      </p>
      <ul>
        <li>
          The problem might have occurred during the download process, due to some connection issues. In this case, we
          advise re-downloading. Re-downloading is absolutely free, once you have purchased the music.
        </li>
        <li>
          If this still doesn&apos;t work, please make sure your file archiver has all the necessary updates installed
          or try using a
          {' '}
          <a href="http://www.7-zip.org/" target="_blank" rel="noopener noreferrer">different one</a>
        </li>
        <li>
          If that doesn&apos;t help, the problem might have occurred because of incompatibility with certain symbols
          in the name of the file. This is usually an OS or a file archiver issue.
        </li>
      </ul>

      <p>
        You can rename the archive
        (e.g. &quot;beauty-and-the-beast-original-motion-picture-soundtrack-deluxe-edition-.zip&quot;
        into &quot;beauty-soundtrack.zip&quot;). Then try again.
      </p>
      <p>
        If you have problems while downloading archives, you can also try downloading track by track. It should
        definitely work.
      </p>
      <p>
        If none of the advice work, please send us a damaged file notice and we will run it for errors.
      </p>
      <HelpContactUs subject={3} />
    </div>
  );
}
